import { actionTypes } from './action';
import { EventConfig } from '../../types/global';

export const initialEventState: EventConfig = {
    startTime: '',
    endTime: '',
    iconUrl: '',
    title: '',
    description: '',
    isOpen: false
};

const eventReducer = (state = initialEventState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_EVENT_CONFIG:
            return {
                ...state,
                ...action.payload,
            };

        case actionTypes.CLEAR_EVENT_CONFIG:
            return { ...initialEventState };

        default:
            return state;
    }
};

export default eventReducer;